var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFavourites = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.958 5.783a.801.801 0 0 0-.695-.54l-4.56-.363L8.728.511a.798.798 0 0 0-1.458 0L5.297 4.88l-4.56.362a.8.8 0 0 0-.496 1.37l3.37 3.286L2.42 15.06a.8.8 0 0 0 1.224.846L8 13.002l4.356 2.904a.8.8 0 0 0 1.214-.885L12.106 9.9l3.63-3.266a.801.801 0 0 0 .222-.852Z",
  fill: "#98A4AF"
})));
export { SvgFavourites as ReactComponent };
export default __webpack_public_path__ + "642019f8e7e10527edc4dc9ed5f64b5a.svg";